export default "__VITE_ASSET__UWLmy8I5__"